<template>
  <div class="tw-fixed tw-inset-0 tw-z-error" v-if="show">
    <div
      class="modal-bg tw-absolute tw-inset-0 tw-bg-mainbg1 tw-opacity-50"
    ></div>
    <div class="md sf-modal tw-absolute tw-inset-0">
      <div class="tw-flex tw-justify-center tw-items-center tw-h-full">
        <div class="sf-dialog-container">
          <div class="tw-h-full">
            <div class="sf-dialog" @click.stop>
              <div class="tw-flex-auto">
                <div class="sf-modal-body tw-text-danger">
                  <ErrorCmpMessage :error="currentError" @close="closeError" />
                  <div class="tw-text-center">
                    <button class="sf-btn sf-btn-danger" @click="closeError">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { apiErrors, clearApiErrors } from "@/state/appState";
import { SfApiError } from "@/types/generalTypes";
import ErrorCmpMessage from "./ErrorCmpMessage.vue";

export default defineComponent({
  components: { ErrorCmpMessage },
  data() {
    return {};
  },
  computed: {
    currentError(): SfApiError | null {
      if (apiErrors.value.length > 0) {
        return apiErrors.value[0];
      }
      return null;
    },
    show(): boolean {
      if (!this.currentError) {
        return false;
      }
      if (this.ignoreError(this.currentError.status, this.currentError.name)) {
        return false;
      }
      return true;
    },
  },
  methods: {
    closeError() {
      clearApiErrors();
    },
    ignoreError(status: number, name: string) {
      if (status == 401) {
        if (name == "loginInvalid" || name == "connectionLimit") {
          return true;
        }
      }
      return false;
    },
  },
});
</script>
